<block-ui [hidden]="!authenticated">
  <app-map></app-map>
</block-ui>